import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/fonticons': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32h448v448h-448v-448zM187 172.9c11.9 0 16.6 4.3 16.3 23l50.7-6.1c0-44.6-30.6-52.8-64.7-52.8-50.8 0-77.3 20.4-77.3 70v21h-28v37.4h22.2c2.9 0 5.8 0 5.8 2.3v111.4c0 5.6-1.5 7.3-6.7 7.9l-21.3 2v25.7h130.7v-25.1l-43.5-4.1c-5.2-0.6-3.2-1.5-3.2-7.3v-112.9h55.7l11.1-37.3h-67.4c-2.9 0 0.6-2 0.6-4.4v-23.3c0-17.5 0.6-27.4 19-27.4zM261.3 414.7h102.6v-25.1l-15.7-2.6c-5.5-0.9-2.9-1.5-2.9-7.3v-151.7h-80.2l-6.7 29.5 24.2 6.4c3.8 1.2 6.7 3.8 6.7 7.9v107.9c0 5.6-2.4 6.7-7.6 7.3l-20.4 2.6v25.1zM342.1 159.2l21.9-24.2-3.5-9.6h-27.7l-15.5-28h-9.3l-15.5 28h-27.7l-3.5 9.6 21.8 24.2-9 33.2 7.3 7.3 31.2-16.6 31.2 16.6 7.3-7.3z'
      }
    ]
  }
})
